import { TourProvider } from '@reactour/tour';
import React, { useState } from 'react';
import { mailboxTourSteps } from '../Tours/Mailbox';
import { Mailbox } from '../Components/Mailbox/Mailbox';

type MailboxesType = {};

function Mailboxes(props: MailboxesType) {
	const [tourStep, setTourStep] = useState(0);
	const [tourFinished, setTourFinished] = useState<boolean>(false);

	return (
		<TourProvider
			steps={mailboxTourSteps}
			padding={0}
			currentStep={tourStep}
			setCurrentStep={(step) => setTourStep(step)}
			className='surface-wrapper'
			onClickClose={(e) => {
				e.setIsOpen(false);
				setTourFinished(true);
			}}
		>
			<Mailbox />
		</TourProvider>
	);
}

export default Mailboxes;
